import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-762aa9b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-0 text-bold"
}
const _hoisted_2 = ["href", "title"]
const _hoisted_3 = {
  key: 1,
  class: "mb-0 text-bold"
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_5 = { class: "pi pi-spin pi-spinner" }
const _hoisted_6 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ml-1 pi pi-exclamation-circle" }, null, -1))
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_ctx.contracts.length)
    ? (_openBlock(), _createBlock(_component_DataTable, {
        key: 0,
        "auto-layout": "",
        class: "mb-3",
        "data-key": "contractNumber",
        "responsive-layout": "stack",
        value: _ctx.contracts
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            key: "contractManager",
            field: "contractManager",
            header: _ctx.$t('myCadac.contractDetail.table.colContractManager'),
            sortable: false
          }, {
            body: _withCtx((item) => [
              (_ctx.userProfile?.isCadacSales || _ctx.userProfile?.isImpersonated)
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                    _createElementVNode("a", {
                      href: item.data.contractManagerCrmUrl,
                      target: "_blank",
                      title: _ctx.$t('common.goToCrm')
                    }, _toDisplayString(item.data.contractManager), 9, _hoisted_2)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(item.data.contractNumber), 1))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            key: "duration",
            field: "duration",
            header: _ctx.$t('myCadac.contractDetail.table.colDuration'),
            sortable: false
          }, {
            body: _withCtx((item) => [
              _createTextVNode(_toDisplayString(_ctx.$tc("myCadac.contractDetail.table.duration", item.data.duration)), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            key: "contractType",
            field: "contractType",
            header: _ctx.$t('myCadac.contractDetail.table.colContractType'),
            sortable: false
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            key: "automaticRenewal",
            field: "automaticRenewal",
            header: _ctx.$t('myCadac.contractDetail.table.colAutomaticRenewal'),
            sortable: false
          }, {
            body: _withCtx((item) => [
              (!item.data.isDatechAutoRenewal && _ctx.vm.editing)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _withDirectives(_createElementVNode("span", null, [
                      _createVNode(_component_InputSwitch, {
                        modelValue: item.data.automaticRenewal,
                        "onUpdate:modelValue": ($event: any) => ((item.data.automaticRenewal) = $event),
                        onClick: ($event: any) => (_ctx.changeAutoRenewal(item.data))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
                    ], 512), [
                      [_vShow, !_ctx.isLoading]
                    ]),
                    _withDirectives(_createElementVNode("i", _hoisted_5, null, 512), [
                      [_vShow, _ctx.isLoading]
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createElementVNode("i", {
                      class: _normalizeClass(
							item.data.automaticRenewal
								? 'pi pi-check text-success mr-1'
								: 'pi pi-times text-danger mr-1'
						)
                    }, null, 2),
                    _createElementVNode("span", null, _toDisplayString(_ctx.getAutomaticRenewalText(item.data.automaticRenewal)), 1)
                  ]))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            key: "endDate",
            field: "endDate",
            header: _ctx.$t('myCadac.contractDetail.table.colExpiresOn'),
            sortable: false
          }, {
            body: _withCtx((item) => [
              (_ctx.shouldShowContractExpirationWarning(item.data))
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(item.data.endDate)) + " ", 1),
                    _createVNode(_component_PopoverIcon, {
                      class: "d-inline-flex",
                      content: 
							_ctx.$tc('myCadac.contractDetail.table.contractExpirationWarning', {
								count: item.data.remainingDays,
							})
						
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 2
                    }, 1032, ["content"])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.formatDate(item.data.endDate)), 1))
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value"]))
    : _createCommentVNode("", true)
}